export const aboutText = `This is a tool for tracking your goals. I made it for myself. You can track yearly, monthly, and daily goals.

I set monthly goals on the 1st of each month, and I set daily goals every morning. Ideally, the small goals contribute toward the larger ones. This habit made me far more productive. I encourage you to try it yourself!

By Ben Shumaker
Personal Website: benshumaker.xyz
`